export const DESCRIPTION =
  'Enter your spend for channels to get the most of your numbers! Unlock powerful features such as Return On Ad Spend (ROAS) and see how much each channel is contributing towards your bottom dollar. When you enter your spend below, your amounts will automatically be saved and reflected to the channels that you’ve entered spend for.'

/**
 * Autosave Statuses
 */
export const STATUS_DEFAULT = 'All changes are autosaved'
export const STATUS_SAVING = 'Saving...'
export const STATUS_SAVED = 'Saved!'
